<template>
  <div class="page-content">
     <!-- 角色搜索以及添加栏目 -->
    <el-row  class="product-menu" type="flex">
      <el-row style="width:80%">
        <el-col :span="4" style="margin-right:20px">
          <el-input placeholder="请输入文件名" v-model="fileName" class="input-with-select" @keyup.13.native="handlerKeyUp">
            <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-date-picker
            @change="timeChange"
            v-model="value1"
            type="datetimerange"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期"
            :default-time="['12:00:00']">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-select v-model="fileType" placeholder="请选择文件类型" @change="selChange" clearable >
            <el-option
            v-for="item in options"
            :key="item.typeNum"
            :label="item.typeName"
            :value="item.typeNum"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row  type="flex" justify="end">
        <el-tooltip content="设备不在线，请先上线设备后再试" placement="top" effect="light" v-if="deviceStatus !== 0 ">
          <el-button :class="deviceStatus !== 0? 'stop':''">
            同步设备文件列表
          </el-button>
        </el-tooltip>
        <el-button @click="syncAllList" :disabled="btnStatus" v-else>
          同步设备文件列表
        </el-button>

        <el-button @click="reflash">
          刷新
        </el-button>
      </el-row>
    </el-row>
    <el-table
        ref=""
        border
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
          <el-table-column
          prop="fileName"
          label="文件名">
        </el-table-column>
          <el-table-column
          prop="fileType"
          label="文件类型">
        </el-table-column>
          <el-table-column
          prop="fileSize"
          label="文件大小">
        </el-table-column>
        <el-table-column
          prop="md5"
          label="Md5">
        </el-table-column>
        <el-table-column
          prop="syncDate"
          label="同步时间">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <div>
              {{scope.row.status === 0 ?'未同步':scope.row.status === 1?'同步成功':scope.row.status === 2?'同步失败':'已删除'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <Pergress :key="scope.row.id" :scope="scope" :productKey="productKey" :deviceName="deviceName" :deviceStatus="deviceStatus" @getServerfileList="getServerfileList"/>
          </template>
        </el-table-column>
      </el-table>
    <el-row class="footer" :span="24">
          <el-col :span="24">
            <el-row :span="24" class="dataListOperation" justify="end" type="flex">
              <el-col :span="12" >
                <el-row :span="24" type="flex" justify="end">
                  <div class="showAll"> 共<span>{{pageParams.total}}</span>条数据</div>
                  <el-pagination
                    layout="prev, pager, next"
                    @current-change="currentChange"
                    :current-page="pageParams.pageNumber"
                    :page-size="pageParams.pageSize"
                    :total="pageParams.total">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
  </div>
</template>
<script>
import Pergress from '@/components/deviceManage/pergress'
import { deviceFileList, syncFileList, queryIncrFileList } from '@/api/fileServer'
export default {
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    },
    deviceStatus: {
      type: Number
    }
  },
  components: {
    Pergress
  },
  data () {
    return {
      pageParams: {
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      tableData: [],
      // 模糊搜索
      fileName: '',
      syncTime: '',
      fileType: '',
      options: [
        {
          typeNum: 0,
          typeName: '日志文件'
        },
        {
          typeNum: 1,
          typeName: 'log文件'
        }
      ],
      // table操作
      status: true, // 控制进度条跟同步按钮得展示
      // 定时器
      timer: '',
      times: 0,
      maxTime: 0,
      // 时间
      value1: '',
      startTime: '',
      endTime: '',
      // 按钮状态控制
      btnStatus: false
    }
  },
  methods: {
    handlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.sel()
      }
    },
    // 刷新
    reflash () {
      this.pageParams.pageNumber = 1
      this.getServerfileList()
    },
    // 搜索功能
    sel () {
      this.pageParams.pageNumber = 1
      this.getServerfileList()
    },
    selChange (val) {
      this.pageParams.pageNumber = 1
      this.getServerfileList()
    },
    timeChange (val) {
      this.pageParams.pageNumber = 1
      if (JSON.stringify(this.value1) !== 'null') {
        this.startTime = this.timePickChange(this.value1[0])
        this.endTime = this.timePickChange(this.value1[1])
      } else {
        this.startTime = ''
        this.endTime = ''
      }
      this.getServerfileList()
    },
    // 时间转换
    timePickChange (time) {
      const d = new Date(time)
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    },
    getServerfileList (searchParams) {
      if (!this.productKey) {
        return
      }
      let params
      if (searchParams) {
        this.pageParams.pageNumber = 1
        params = Object.assign({ productKey: this.productKey }, searchParams)
      } else {
        let Obj = {}
        if (this.deviceName) {
          Obj = {
            deviceName: this.deviceName
          }
        }
        params = Object.assign({ productKey: this.productKey }, Obj, this.pageParams)
        params.fileName = this.fileName
        params.createTime = this.syncTime
        params.fileType = this.fileType
        params.startTime = this.startTime
        params.endTime = this.endTime
      }
      deviceFileList(params).then(res => {
        res = res.data
        this.pageParams.total = res.data.total
        this.tableData = res.data.fileProperties
      })
    },
    // 同步所有列表日志
    syncAllList () {
      this.btnStatus = true
      const params = {
        productKey: this.productKey,
        deviceName: this.deviceName,
        fileType: 0
      }
      syncFileList(params).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          this.timer = setInterval(() => {
            this.queryIncrFile(params)
          }, 1000)
        } else {
          this.btnStatus = false
        }
      }).catch((error) => {
        if (error.response.status !== 200) {
          this.$message({
            type: 'error',
            message: '请求失败,请稍后再试'
          })
          setTimeout(() => {
            this.btnStatus = false
          }, 500)
        }
      })
    },
    // 轮询增量函数
    queryIncrFile (params) {
      queryIncrFileList(params).then((Res) => {
        // 进行对数据的拼接
        this.times++
        if (this.times > 10) {
          clearInterval(this.timer)
          this.$message({
            type: 'warning',
            message: '同步文件超时,请稍后再试或进行手动刷新'
          })
          this.times = 0
          this.btnStatus = false
          this.getServerfileList()
        } else {
          if (Res.data.data && Res.data.data.isLast === 1) {
            clearInterval(this.timer)
            this.times = 0
            this.btnStatus = false
            this.getServerfileList()
          } else {
            this.btnStatus = false
          }
        }
      })
    },
    currentChange (val) {
      this.pageParams.pageNumber = val
      this.getServerfileList()
    }
  },
  created () {
    console.log(this.productKey, this.deviceName, this.deviceStatus)
    this.getServerfileList()
  },
  watch: {
    productKey () {
      this.getServerfileList()
    },
    fileName: {
      handler (val) {
        if (val === '') {
          this.pageParams.pageNumber = 1
          this.getServerfileList()
        }
      }
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }

}
</script>
<style lang="less" scope>
.page-content{
  .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }
  .footer{
      padding: 20px 10px ;
    }
  .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
  .stop{
      cursor: not-allowed;
      color: #c1c1c1;
    }
}
</style>
